import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Col, Modal, Row, Card, Table, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import {
	updateCaminhaoSelecionado,
	updateProdutosList,
	updateRomaneiosList,
} from "../../../redux/slicers/user";
import {
	compareDates,
	getAllData,
	getStatusTrackingPedidos,
	verificaTipoUsuario,
} from "../../../services/Servicos";

import "../../modal/Modal.scss";
import CarregarCaminhaoGestor from "../../carregamento/CarregarCaminhaoGestor";
import { removeAll } from "../../../redux/slicers/carga";
import MonitoramentoCargaGestor from "../../carregamento/MonitoramentoCargaGestor";
import {
	filtroDinamicoArrays,
	removerDadosDuplicados,
} from "../../../services/helpers";
import Loading from "../../loading/Loading";
import ModalError from "../../modal/ModalError";
import ScrollbarLeft from "../../scrollbars/ScrollbarLeft";
import HeadTable from "../../table/head/HeadRow";
import BodyRowPedidosFromPedidos from "../../table/body/BodyRowPedidosFromPedidos";
import ExportToExcel from "../../exportToExcel/ExportToExcel";
import HeadRowNew from "../../table/head/HeadRowNew";
import ModalErrorPretty from "../../modal/ModalErrorPretty";

export default function ModalMonitorarPedidosVST({
	show,
	setShow,
	filial,
	operacoes,
}) {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.userSlice);

	const handlerSimpleClose = () => {
		setShow((last) => ({
			...last,
			flag: false,
			target: 0,
			style: {
				scale: "1",
				zIndex: "1",
				// , transition: '0.5s'
			},
		}));
	};

	return (
		<>
			<Modal
				show={show}
				onHide={handlerSimpleClose}
				backdrop="static"
				keyboard={false}
				centered
				size="xl"
			>
				<Modal.Header closeButton>
					<Modal.Title>Area de Monitoramento - {filial}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<MonitoramentoPedidosLocal operacoesList={operacoes} />
				</Modal.Body>
				<Modal.Footer>
					<Col sm="3">
						<Button variant="primary" onClick={handlerSimpleClose}>
							Fechar
						</Button>
					</Col>
				</Modal.Footer>
			</Modal>
		</>
	);
}

function MonitoramentoPedidosLocal({ operacoesList }) {
	const [pedidos, setPedidos] = useState([]);
	const [pedidosFiltrados, setPedidosFiltrados] = useState([]);
	const [error, setError] = useState({ show: false, message: ""});
	const [sorted, setSorted] = useState({ option: "", order: 1 });

	useEffect(() => {
		Object.keys(operacoesList).forEach((el) => {
			setPedidos((last) => [...last, ...operacoesList[el].vendas]);
		});
	}, []);

	return (
		<Fragment>
			{pedidos.length ? (
				<ShowPedidosEmTabela
					pedidosFiltrados={pedidosFiltrados}
					pedidos={pedidos}
					sorted={sorted}
					setSorted={setSorted}
				/>
			) : (
				""
			)}

			{error.show ? (
				<ModalErrorPretty
					setShow={setError}
					{...error}
				/>
			) : (
				""
			)}
		</Fragment>
	);
}

function ShowPedidosEmTabela({ pedidos, setPedidos = () => {} }) {
	const tableRef = useRef();
	const tbody = useRef();

	const [pedidosL, setPedidosL] = useState([
		...pedidos.map((item) => ({ ...item })),
	]);
	const [indexList, setIndexList] = useState(15000);
	const [error, setError] = useState({
		flag: false,
		msg: "",
	});
	const [headList, setHead] = useState([
		"index",
		"codigoPedido",
		"data_cadastro",
		"dias_producao",
		"data_faturamento",
		"dias_logistica",
		"data_logistica",
		"clienteRetira",
		"status_pedido",
		"nomefunc",
		"tipoOperacao",
		"nomeRazao",
		"pesoBruto",
		"desccidade",
		"vlrVenda",
		"nfeNumero"
	]);
	const [filters, setFilters] = useState([]);

	const [filtersNew, setFiltersNew] = useState({});
	const [dataParam, setDataParam] = useState({
		show: false,
		data_inicial: null,
		data_final: null,
		filtro: "",
	});

	const [loadingLogistica, setLoadingLogistica] = useState(false);
	const [pedidosFiltrados, setPedidosFiltrados] = useState([]);

	const onClickRemoveFilter = (e) => {
		e.preventDefault();
		const value = e.target.parentNode.firstElementChild.innerText;
		const [key, keyValue] = value.split(":");
		//
		setFilters((last) => [
			...last.filter(
				(item) =>
					String(item[key]).replaceAll(" ", "") !== keyValue.replaceAll(" ", "")
			),
		]);
	};

	useEffect(() => {
		if (!filters.length) {
			setPedidosFiltrados([]);
			return;
		}

		let testeFilters = {};

		filters.forEach((ele) => {
			// testeFilters[arguments[ele]]
			const param = Object.getOwnPropertyNames(ele)[0];
			testeFilters[param] = [];
		});

		filters.forEach((ele) => {
			// testeFilters[arguments[ele]]
			const param = Object.getOwnPropertyNames(ele)[0];
			// testeFilters[param].push(ele[param])
			testeFilters[param].push(String(ele[param]).toLowerCase());

			if (String(ele[param]).toLowerCase() == "false") {
				testeFilters[param].push("null");
			}
		});

		let arrayRetorno = [pedidosL];

		Object.keys(testeFilters).forEach((key, index) => {
			arrayRetorno.push(
				filtroDinamicoArrays(
					testeFilters,
					key,
					arrayRetorno[arrayRetorno.length - 1]
				)
			);
		});

		const arrayF = removerDadosDuplicados(
			arrayRetorno[arrayRetorno.length - 1],
			"codigoPedido"
		);

		setPedidosFiltrados(arrayF);
	}, [filters]);

	useEffect(() => {
		async function getInfoAsync() {
			try {
				const filial = pedidosL[0].idFilial
				let { data } = await getAllData(`pedidos/monitoramento/${filial}?pedidos=${pedidosL.map(i => i.codigoPedido).join(",")}`)
				
				let pedidos = pedidosL
					.map(i => ({... i, data: data.find(ii => ii.numero_pedido == i.codigoPedido)}))
					.map((pedido) => {
					let dias_logistica = compareDates(pedido.dtfaturamento, new Date());
					let data_logistica = "N/A";
					
					let returnedData = { ...pedido }
					

					if (pedido.data) {
						let data_formatada = new Date(pedido.data.createdAt);
						data_formatada.setHours(-4, 0, 0);

						data_logistica = data_formatada.toLocaleDateString("pt-br", {
							timeZone: "UTC",
						});
						dias_logistica = compareDates(
							pedido.dtfaturamento,
							data_formatada.toISOString()
						);
					}
					delete returnedData.data
					return { ...returnedData, data_logistica, dias_logistica, carga: pedido?.data?.cargas_id ?? null }
				});
				setPedidosL(pedidos)
			} catch (error) {
				console.log(error.message)
			} finally {
				setLoadingLogistica(false)
			}
		}
		
		setLoadingLogistica(true)
		getInfoAsync();
	}, []);

	return (
		<Fragment>
			<div className="section-filters-table">
				<Row className="mt-2 row-filters">
					<Col>
						<div>
							{filters.map((item, key) =>
								Object.keys(item).map((key, index) => {
									return (
										<span className="filters-card" key={index}>
											<span className="filters">
												<span className="title">
													{key}: {item[key]}
												</span>
												<i
													className="bi bi-x-lg"
													onClick={onClickRemoveFilter}
												></i>
											</span>
										</span>
									);
								})
							)}
						</div>
					</Col>
				</Row>
			</div>
			
			{/* Legenda de cores para dias de logística */}
			<div className="mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
				<h6 className="mb-2">Legenda - Dias de Logística:</h6>
				<div className="d-flex flex-wrap gap-3">
					<div className="d-flex align-items-center">
						<div 
							style={{
								width: '20px',
								height: '20px',
								backgroundColor: '#2e7d32',
								border: '1px solid #1b5e20',
								borderRadius: '4px',
								marginRight: '8px'
							}}
						></div>
						<span style={{ fontSize: '0.9rem', color: '#2e7d32', fontWeight: 'bold' }}>
							Até 7 dias
						</span>
					</div>
					<div className="d-flex align-items-center">
						<div 
							style={{
								width: '20px',
								height: '20px',
								backgroundColor: '#ff8f00',
								border: '1px solid #e65100',
								borderRadius: '4px',
								marginRight: '8px'
							}}
						></div>
						<span style={{ fontSize: '0.9rem', color: '#ff8f00', fontWeight: 'bold' }}>
							7 a 14 dias
						</span>
					</div>
					<div className="d-flex align-items-center">
						<div 
							style={{
								width: '20px',
								height: '20px',
								backgroundColor: '#d32f2f',
								border: '1px solid #b71c1c',
								borderRadius: '4px',
								marginRight: '8px'
							}}
						></div>
						<span style={{ fontSize: '0.9rem', color: '#d32f2f', fontWeight: 'bold' }}>
							14 a 28 dias
						</span>
					</div>
					<div className="d-flex align-items-center">
						<div 
							style={{
								width: '20px',
								height: '20px',
								backgroundColor: '#000000',
								border: '1px solid #000000',
								borderRadius: '4px',
								marginRight: '8px'
							}}
						></div>
						<span style={{ fontSize: '0.9rem', color: '#000000', fontWeight: 'bold' }}>
							Mais de 28 dias
						</span>
					</div>
				</div>
			</div>
			
			<div className="card-header pb-2">
				<Row className="justify-content-between">
					<Col sm="12" md="6" lg="8">
						<h3 style={{ display: "flex", alignItems: "center" }}>
							Tabela de Dados
							<span className={`carregando-logistica ${loadingLogistica? 'show': 'hidden'}`}>{loadingLogistica ? "Carregando Dados de Logistica..." : ""} </span>
						</h3>
					
					</Col>
					<Col sm="12" md="6" lg="2">
						<ExportToExcel
							tableName="Pedidos da Filial"
							reference={pedidosFiltrados.length ? pedidosFiltrados : pedidosL}
							paramExport={headList}
						/>
					</Col>
				</Row>
			</div>
			<div className="section-filters-table">
				<ScrollbarLeft tableRef={tableRef} coluna2={3} maxima_distancia={70} />
				<div
					className="responsive-table tes"
					ref={tableRef}
					style={{ height: "600px", maxHeight: "unset" }}
				>
					<Table hover size="sm" bordered>
						<thead style={{ zIndex: 49 }}>
							<HeadRowNew
								arrayValues={pedidosL}
								headerList={headList}
								setArrayFilters={setFiltersNew}
								arrayFilters={filtersNew}
								setFiltersOld={setFilters}
								filtersOld={filters}
								setDataParam={setDataParam}
								arrayPedidos={
									pedidosFiltrados.length ? pedidosFiltrados : pedidosL
								}
								setPedidos={
									pedidosFiltrados.length ? setPedidosFiltrados : setPedidosL
								}
							/>
						</thead>
						<tbody ref={tbody}>
							{pedidosFiltrados.length
								? pedidosFiltrados.map((item, index) => {
										if (index < indexList) {
											return (
												<BodyRowPedidosFromPedidos
													key={index}
													bodyList={item}
													headList={headList}
													index={index}
													tableLength={indexList}
													setArrayFilters={setFiltersNew}
													setPedidos={setPedidosL}
												/>
											);
										}
								  })
								: pedidosL.map((item, index) => {
										if (index < indexList) {
											return (
												<BodyRowPedidosFromPedidos
													key={index}
													bodyList={item}
													headList={headList}
													index={index}
													tableLength={indexList}
													setArrayFilters={setFiltersNew}
													setPedidos={setPedidosL}
												/>
											);
										}
								  })}
						</tbody>
					</Table>
					{/* CASO NÃO HAJA MAIS VENDAS, REMOVER LOADING  */}
					{pedidosFiltrados ? (
						indexList <= pedidosFiltrados.length ? (
							<Loading color={"black"} msg="Loading" />
						) : (
							""
						)
					) : indexList <= pedidos.length ? (
						<Loading color={"black"} msg="Loading" />
					) : (
						""
					)}
					{/* CASO NÃO HAJA MAIS VENDAS, REMOVER LOADING  */}
					{error.flag ? (
						<ModalError
							msg={error.msg}
							title={"ATENÇÃO"}
							show={error.flag}
							setShow={setError}
						/>
					) : (
						""
					)}
					<br />
				</div>
			</div>
		</Fragment>
	);
}
